import {useState} from 'react'
import OrganizationConfigurationsForm from './OrganizationConfigurationsForm';
import OrganizationConfigurationsList from './OrganizationConfigurationsList';

const OrganizationConfigurations = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
  return (
    <>
      {fromIsShown ? (
          <OrganizationConfigurationsForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <OrganizationConfigurationsList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default OrganizationConfigurations